<template>
  <section class="empty-list">
    <img :src="require(`../assets/images/empty-icons/${imgFileName}`)" alt role="presentation" width="160" height="160">
    <p class="title">{{title}}</p>
    <p class="description">{{action}}</p>
  </section>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    title: {
      type: String,
      required: true
    },
    imgFileName: {
      type: String,
      default: 'any.png'
    },
    action: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/vuesax/_variables';

  .empty-list {
    display: flex;
    width: 100%;
    padding: $size-3 0;
    min-height: 70vh;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    color: rgba(0, 0, 0, 0.48);
  }

  .title {
    font-weight: 700;
    font-size: $font-size-base;
  }

  .description {
    font-size: $font-size-small;
  }
</style>
